import styled from "styled-components";
import { Link } from "react-router-dom";

export const FooterSection = styled("footer")`
  background: #071a38;
  padding: 5rem 0 0;
  color: white;
  transition: background 0.3s ease;
`;

export const FooterContent = styled("div")`
  padding-bottom: 1rem;
`;

export const LogoContainer = styled(Link)`
  position: relative;
  display: flex;
  align-items: center;
  width: 160px;
  height: 50px;
  overflow: hidden;
  margin-bottom: 1rem;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.96);
  
  img {
    position: absolute;
    top: -39px;
    left: 0;
    width: 160px;
    height: 160px;
    object-fit: contain;
  }
`;

export const Title = styled("h4")`
  font-size: 0.875rem;
  text-transform: uppercase;
  color: white;
  font-weight: 700;
  margin-bottom: 1.25rem;
  letter-spacing: 0.12em;

  @media screen and (max-width: 414px) {
    margin-top: 2rem;
  }
`;

export const NavLink = styled(Link)`
  display: block;
  font-size: 1rem;
  margin-bottom: 0.625rem;
  transition: all 0.3s ease;
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;

  &:hover,
  &:active,
  &:focus {
    color: var(--secondary-teal);
    transform: translateX(4px);
  }
`;

export const Para = styled("div")`
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.95rem;
  line-height: 1.7;
  margin-bottom: 0.5rem;
`;

export const Large = styled(Link)`
  font-size: 0.95rem;
  color: rgba(255, 255, 255, 0.7);
  cursor: pointer;
  transition: all 0.3s ease;
  line-height: 1.7;
  display: block;
  margin-bottom: 0.5rem;
  text-decoration: none;

  &:hover {
    color: var(--secondary-teal);
    transform: translateX(4px);
  }
`;

export const SocialLinks = styled("div")`
  display: flex;
  gap: 1rem;
  margin-top: 1.5rem;
`;

export const SocialIcon = styled("a")`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.1);
  color: white;
  transition: all 0.3s ease;
  cursor: pointer;
  
  svg {
    width: 18px;
    height: 18px;
  }

  &:hover {
    background: var(--secondary-teal);
    color: white;
    transform: translateY(-3px);
    box-shadow: 0 8px 16px rgba(0, 168, 150, 0.3);
  }
`;

export const Copyright = styled("div")`
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding: 1.75rem 0;
  margin-top: 2.5rem;
  
  @media screen and (max-width: 768px) {
    text-align: center;
    
    ${Para} {
      margin-bottom: 0.5rem;
    }
    
    .ant-col {
      text-align: center !important;
    }
  }
`;
